import { Component, OnInit, ViewChild, Directive, Input } from '@angular/core';
import { siniestralidadService } from "./siniestralidad.service";
import { ClienteLogin, ClienteXCiudad,ConsultaCliente } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { DatosGeneralesEntity } from "../entities/datos_generales_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { PolizaEntity,BusquedaSiniestralidad ,TitularVam} from "../entities/polizas_cliente_entity";
import { AplicacionesTransporteComponent } from "../aplicacionesTransporte/aplicaciones-transporte.component";
import { ExclusionVehiculos } from "../solicitudes/solicitud-vehiculos.component";
import { ExclusionVehiculosService } from "../solicitudes/solicitud-vehiculos.service";
import { ExclusionEquipos } from "../solicitudes/solicitud-equipo.component";
import { ExclusionEquiposService } from "../solicitudes/solicitud-equipo.service";
import { PolizasVencidasNoLiberadasService } from "../fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service";
import { PolizasVencidasNoLiberadasEntity } from "../fianzas/entities/polizas-vencidasnoLiberadas_entity";
import { ComboBox } from "../../../components/common/utils/combobox";
import { ClienteVAM, UsuarioVamTit } from '../../login/cliente_login';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';
import { CalendarFechaNac } from "../../../components/common/utils/calendarFechaNacParametros";
import { PolizaVAM, SiniestralidadClientes, ResumenSiniestralidad, SiniestralidadMaternidad, RankingDiagnosticos, ProveedoresSiniestralidad,BusquedaFacturacion } from '../entities/vam_entities';
import { EstadosService } from '../../../components/common/utils/estados.service';
import { Objeto } from '../../../components/common/utils/objeto-generico';
import { Tracking, ConsultaTracking, PantallaConsultaTracking, EstadisticoTracking } from '../../../components/common/utils/entities/tracking-siniestros';
import { Titulares, VamTitularEntity } from '../../vam/titulares/entities/vam_titulares_entity';
import { CompleterData } from 'ng2-completer/services/completer-data';
import { CompleterService } from 'ng2-completer/services/completer-service';
import { CompleterItem, LocalData } from 'ng2-completer';
import { Archivo } from '../../../components/common/utils/entities/util_entity';
import { MovimientosVamService } from '../vamEmpresa/movimientos/movimientosVam.service';

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'siniestros',
    providers: [],
    templateUrl: 'siniestros.template.html'

})

export class siniestros extends CalendarFechaNac implements OnInit {
    usuario: ClienteLogin;
    polizas: PolizaEntity[];
    public showLoader: string;
    opcion: number;
    polizaContratada: PolizaEntity;
    show: boolean;
    showVeh: boolean;
    showEqu: boolean;
    showOtr: boolean;
    showRed: boolean;
    showPlanes: boolean;
    showListados: boolean;
    showSiniestralidad: boolean;
    showMovimientos: boolean;
    banderaFianza: boolean;
    banderaCredito: boolean;
    opciones: boolean;
    polizaDetalle: PolizasVencidasNoLiberadasEntity;
    detallePolizas1: PolizasVencidasNoLiberadasEntity[];
    @ViewChild('detallePolizas')
    modal: ModalComponent;
    poliza: string;
    rutaMovimientos: boolean;
    opcionSeleccionada: number = 0;
    rowSelect: number;
    showSolicitudes: boolean;
    opcionCliente: number;
    comboClientes: ComboBox[];
    busqueda: BusquedaSiniestralidad;
    opcionBusqueda: number;
    codigoGrupo: number;
    codigoCliente: number;
    codigounidad: number;
    usuarioVam: UsuarioVamTit;
    titular:TitularVam;
    usuarioempresaretrive: ClienteXCiudad;
    public resumen;
    showTab: boolean;
    public DiagnosticoPorReclamo;
    public DetalleProveedorXReclamo;
    public DetalleSinMaternidad;
    public TitularesMayorValor;
    public TitularesMayorNumeroReclamos;
    public DetalleTitularesMayorValor;
    public DetalleMayorNumeroReclamos;
    public DetalleProveedorXValor;
    public top;
     cabecera : PolizaVAM;
     detalles : PolizaEntity;
    CodigoCiudad: number;
    comboTipoNegocio: ComboBox[];
    comboRamos: ComboBox[];
    comboAseguradora:ComboBox[];
    comboPlanes:ComboBox[];
    Estados: Objeto[];
    consulta: ConsultaTracking; 
    siniestros: Tracking[];
    searchStr: string;
    identificacionTitular: string;
    dataService: LocalData;
    titulares: Titulares[];
    listaTitulares: VamTitularEntity[];
    CodigoTitular:number;
    NotasCobranza: Tracking[];

    constructor(
        private siniestralidadService: siniestralidadService,
        private exclusionVehiculosService: ExclusionVehiculosService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public polizasLiberadasService: PolizasVencidasNoLiberadasService,
        private completerService: CompleterService,
        public movimientosService: MovimientosVamService,
        private consultarVAM: ConsultarUsuarioVAM) { 
            super();
            this.resumen = new ResumenSiniestralidad();
            this.DiagnosticoPorReclamo = new RankingDiagnosticos();
            this.DetalleProveedorXReclamo = new ProveedoresSiniestralidad();
            this.showTab = false;
            this.cabecera=new PolizaVAM();
            this.detalles=new PolizaEntity();
            let estados = new EstadosService();
            this.Estados = estados.EstadosSinTracking;
            this.titulares = new Array<Titulares>();
            this.listaTitulares = new Array<VamTitularEntity>();
            this.CodigoTitular=0;
            this.NotasCobranza = [];
            this.dataService = completerService.local(this.titulares, 'NombreTitular', 'NombreTitular');
         }

    ngOnInit() {
        this.opcionCliente = 1;
        this.codigoGrupo = 0;
        this.opcionBusqueda = 1;
        this.consulta = new ConsultaTracking();
        //Inicializando busqueda
      
        try {
            this.usuarioempresaretrive = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            this.usuarioempresaretrive = this.sesionStorageService.retrieve("usuarioempresa");
        }
       let cliente = this.usuarioempresaretrive.CodigoCliente;
       this.CodigoCiudad= this.usuarioempresaretrive.Ciudad;
       this.codigounidad= this.usuarioempresaretrive.CodigoUnidad;
       this.codigoGrupo=this.usuarioempresaretrive.CodigoGrupo;
        //console.log(this.usuarioempresaretrive);
        //console.log(sessionStorage.getItem("unidad"));
        this.busqueda = new BusquedaSiniestralidad();
        this.busqueda.CodigoPlan = 0;
        this.busqueda.CodigoRamo = "0";
        this.busqueda.CodigoCiudad =  this.CodigoCiudad;
        this.busqueda.CodigoUnidad = Number(sessionStorage.getItem("unidad"));
        this.busqueda.TopRegistros = 10;
        this.busqueda.TipoFecha = 1;
        this.busqueda.CodigoTipoNegocio=0;
        this.busqueda.CodigoAseguradora=0;
        this.consulta.Estado=1;
        this.showSiniestralidad = false;
        this.searchStr = "";
        this.identificacionTitular= "";
        this.identificacionTitular = "";
       

        if ((cliente != null && Number(cliente) > 0)) {
            this.showLoader = "sk-loading";
            
            if (cliente != null) {
                this.codigoCliente = Number(cliente);
                this.busqueda.CodigoCliente = this.codigoCliente;
            }

            let consultaCliente = new ConsultaCliente();
            consultaCliente.Cliente = this.codigoCliente;
            consultaCliente.Grupo = this.usuarioempresaretrive.CodigoGrupo;
            consultaCliente.Ciudad = this.CodigoCiudad;
            consultaCliente.Unidad = Number(sessionStorage.getItem("unidad"));
            this.siniestralidadService.getClientes(consultaCliente).subscribe(infoPantalla => {
                this.comboClientes = infoPantalla;
                this.showLoader = "";
               // this. consultarTipoDeNegocio();
               // this.consutarRamos();
               // this.consultarGrupos(consultaCliente);
               // this.consultarDatosCliente(consultaCliente);

               //console.log(infoPantalla);
                
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los clientes',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });

            this.siniestralidadService.consultarTitularesDependientes(consultaCliente).subscribe(
                result => {
                    this.listaTitulares = result;
                    this.titulares = new Array<Titulares>();
                    this.listaTitulares.forEach(a => {
                        let titular = new Titulares();
                        titular.CodigoTitular = a.CodigoTitular;
                        titular.NombreTitular = a.NombreCompletoTitular;
                        this.titulares.push(titular);
                    });
                    this.dataService = this.completerService.local(this.titulares, 'NombreTitular', 'NombreTitular');
                   
                },
                error => {
                    this.handleError.redirectUrl(error);
                    this.showLoader = "";
                }
            );
        }
        else {
            swal({
                title: 'Alerta',
                text: 'Seleccione un cliente o grupo para consultar su siniestralidad.',
                type: 'warning',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        }
       this.consultarNotaCobranzas();
        this.siniestros = [];
    }


    rutaParaConsultaPolizas(segmento: number, segmentoAlterno: number) {
        // this.polizasContratadasService.consultaPolizasContratadas(segmento, segmentoAlterno)
        //     .subscribe(
        //     polizas => {
        //         this.polizas = polizas;
        //         this.showLoader = "";
        //     },
        //     error => { this.handleError.redirectUrl(error); }
        //     );
    }

    consultarDetalle() {
        this.showLoader = "sk-loading"
        this.showTab = false;

        this.detalles.CodigoCiudad =  this.CodigoCiudad;
        this.detalles.CodigoCliente = this.busqueda.CodigoCliente;
        this.detalles.CodigoUnidad = this.codigounidad;
        this.detalles.CodigoGrupo =this.codigoGrupo;
        this.detalles.CodigoRamo=this.busqueda.CodigoRamo;
       // this.cabecera.FechaDesde=this.busqueda.FechaDesde;
       // this.cabecera.FechaHasta=this.busqueda.FechaHasta;
        this.cabecera.TipoFecha=this.busqueda.TipoFecha;
        this.cabecera.TopRegistros=this.busqueda.TopRegistros;
        this.cabecera.Poliza=this.detalles;
        this.detalles.CodigoTipoNegocio=this.busqueda.CodigoTipoNegocio;
        this.detalles.Opcion=this.opcionCliente;
       //this.cabecera.Poliza=this.detalles;
       console.log(this.codigoGrupo);
        this.siniestralidadService.consultaSiniestralidadVAMEmpresa(this.cabecera).subscribe(
            result => {
                if (result.Clientes != null || result.DetalleDiagnostico != null || result.DiagnosticoXReclamo != null || result.Maternidad != null || result.ProveedorXReclamo != null || result.ProveedorXValor != null || result.RankingTitulares != null || result.Resumen != null) {
                    this.showTab = true;
                    this.resumen = result.Resumen;
                    this.DiagnosticoPorReclamo = result.DiagnosticoXReclamo;//aqui
                     this.DetalleSinMaternidad = result.Maternidad;//aqui
                     this.TitularesMayorValor = result.RankingTitulares.TitularesMayorValor;//aqui
                     this.TitularesMayorNumeroReclamos = result.RankingTitulares.TitularesMayorNumeroReclamos;//aqui
                     this.DetalleTitularesMayorValor = result.RankingTitulares.DetalleTitularesMayorValor;//aqui
                    this.DetalleMayorNumeroReclamos = result.RankingTitulares.DetalleTitularesMayorNumeroReclamos;
                    this.DetalleSinMaternidad = result.Maternidad;//aqui
                     this.DetalleProveedorXReclamo = result.ProveedorXReclamo;
                     this.DetalleProveedorXValor = result.ProveedorXValor;
                     this.top = this.cabecera.TopRegistros;
                     this.showLoader = "";
                }else{
                    swal({
                        title: 'No existe información',
                        text: 'El reporte de siniestralidad no se encuentra disponible',
                        type: 'info'
                    })
                }
               
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }

   

     onCambiarCliente() {
        this.showSiniestralidad = false;
        this.busqueda.CodigoCliente = 0;
        this.busqueda.CodigoGrupo = 0;
        this.busqueda.CodigoRamo = "0";
    console.log(this.opcionCliente)
        if (this.opcionCliente == 2) {
            this.busqueda.CodigoGrupo = this.codigoGrupo;
            this.consulta.CodigoGrupo=this.usuarioempresaretrive.CodigoGrupo;
            //this.consutarRamos();
        } else {
            this.busqueda.CodigoGrupo = 0;
            this.consulta.CodigoGrupo=0;
        }
        console.log(this.consulta.CodigoGrupo)
    }

    set dateFechaDesde(e) {
        this.cabecera.FechaDesde = new Date(e);
    }

    get dateFechaDesde() {
        if (this.cabecera.FechaDesde != undefined) {
            try {
                let a = this.cabecera.FechaDesde.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.cabecera.FechaDesde.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    set dateFechaHasta(e) {
        this.cabecera.FechaHasta = new Date(e);
    }

    get dateFechaHasta() {
        if (this.cabecera.FechaHasta != undefined) {
            try {
                let a = this.cabecera.FechaHasta.toISOString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                let a = this.cabecera.FechaHasta.toString().substring(0, 10);
                let b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    consultarTipoDeNegocio() {
        if (this.codigoCliente != 0 || this.codigoGrupo != 0) {
            this.showLoader = "sk-loading";
            let busquedaFacturacion=new BusquedaFacturacion();
            busquedaFacturacion.CodigoCiudad=this.CodigoCiudad;
            busquedaFacturacion.CodigoCliente=this.codigoCliente
            busquedaFacturacion.CodigoGrupo=this.codigoGrupo;
            this.siniestralidadService.getTipoNegocio(busquedaFacturacion).subscribe(data => {
                this.comboTipoNegocio = data;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los clientes',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    consutarRamos() {
        this.showLoader = "sk-loading";
        this.showSiniestralidad = false;
        this.busqueda.CodigoRamo = "0";
        this.busqueda.CodigoTipoNegocio=0;
        this.busqueda.CodigoAseguradora=0;
        let busqueda=new BusquedaSiniestralidad();
        busqueda.CodigoCiudad=this.CodigoCiudad;
        busqueda.CodigoCliente=this.busqueda.CodigoCliente
        busqueda.CodigoGrupo=this.codigoGrupo;
        this.siniestralidadService.getRamos(busqueda).subscribe(ramos => {
           // this.comboRamos = ramos;
            this.showLoader = "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al cargar los ramos del cliente',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
    }
    consultarAseguradora() {
        if (this.busqueda.CodigoTipoNegocio != 0 || (this.busqueda.CodigoRamo != null || this.busqueda.CodigoRamo != undefined)) {
            this.showLoader = "sk-loading";
            this.siniestralidadService.getAseguradora(this.busqueda).subscribe(data => {
                this.comboAseguradora = data;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar los aseguradoras',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    consultarGrupos(ConsultaCliente: ConsultaCliente) {
       
        if (ConsultaCliente != null || ConsultaCliente != undefined) {
            this.showLoader = "sk-loading";
            this.siniestralidadService.getGrupo(ConsultaCliente).subscribe(data => {
                this.codigoGrupo = data;
                console.log(Number(data));
                console.log(data);
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar el grupos',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    consutarPlanes() {
        this.showLoader = "sk-loading";
        this.siniestralidadService.getPlanes(this.busqueda).subscribe(planes => {
            this.comboPlanes = planes;
            this.showLoader = "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al cargar los clientes',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
    }
    consultarDatosCliente(ConsultaCliente: ConsultaCliente) {
       
        if (ConsultaCliente != null || ConsultaCliente != undefined) {
            this.showLoader = "sk-loading";
            this.siniestralidadService.getDatosCliente(ConsultaCliente).subscribe(data => {
                this.codigounidad = data.Unidad;
                this.showLoader = "";
            }, error => {
                this.showLoader = "";
                swal({
                    title: 'Error al cargar el grupos',
                    text: error,
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                })
            });
        }

    }
    exportarSiniestralidad() {
        this.showLoader = "sk-loading"
        this.showTab = false;

        this.consulta.CodigoCliente=this.busqueda.CodigoCliente;
        this.consulta.CodigoCiudad=this.CodigoCiudad;
        this.consulta.Unidad=this.codigounidad;
        this.consulta.FechaDesde=this.cabecera.FechaDesde;
        this.consulta.FechaHasta=this.cabecera.FechaHasta;
         this.consulta.TipoGestion=1;
        this.consulta.TipoFecha=this.busqueda.TipoFecha;
        this.consulta.CodigoTitular=this.CodigoTitular;
        this.siniestralidadService.consultaSiniestrosTrackngExcel(this.consulta).subscribe(excel => {
            var  a  =  document.createElement("a");
            document.body.appendChild(a);
            a.className  =  "hidden"
            let  fileBlob  = excel.blob();
            let  blob  =  new  Blob([fileBlob], {
                type:  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            let  url  =  window.URL.createObjectURL(blob);
            a.href  =  url;
            a.download  = "DetalleSiniestralidad.xlsx";
            if  (window.navigator  &&  window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob,  "DetalleTrackingSiniestros.xlsx");
            }
            else  {
                a.click();
                window.URL.revokeObjectURL(url);
            }
            this.showLoader  =  "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al exportar siniestralidad',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            });
            console.log(error)
        })
    }

    consultarTracking() {
        this.siniestros = [];
        this.showLoader = "sk-loading";
        
        //this.consulta.CodigoGrupo=this.codigoGrupo;
        this.consulta.CodigoCliente=this.busqueda.CodigoCliente;
        this.consulta.CodigoCiudad=this.CodigoCiudad;
        this.consulta.Unidad=this.codigounidad;
        this.consulta.FechaDesde=this.cabecera.FechaDesde;
        this.consulta.FechaHasta=this.cabecera.FechaHasta;
        this.consulta.TipoGestion=1;
        this.consulta.TipoFecha=this.busqueda.TipoFecha;
        this.consulta.CodigoTitular=this.CodigoTitular;
        this.siniestralidadService.consultaSiniestrosTrackng(this.consulta).subscribe(res => {
            this.showLoader = "";
            this.siniestros = res;
            // this.siniestros.forEach(item => {
            //     item.NombreEstado = this.Estados.filter(a => a.Id == item.Estado)[0].Nombre;
            // }
            // );
               
            },
            error => {
                this.showLoader = "";
            swal({
                title: 'Error al cargar',
                text: 'Error al consultar los registros.',
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
            }
        );
        
    }

    DescargarAdjuntosTrackin(siniestro:Tracking){
        console.log(siniestro);
        this.siniestralidadService.getAdjuntoSiniestro(siniestro).subscribe(result => {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.className = "hidden";
            let fileBlob = result.blob();
            let blob = new Blob([fileBlob], {
                type: 'application/pdf' // must match the Accept type
            });
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            let codigoAutogenerado = new Date();
            a.download = siniestro.NumSiniestroAse + ".pdf";
    
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, siniestro.NumSiniestroAse + ".pdf");
            }
            else {
                a.click();
                window.URL.revokeObjectURL(url);
                // var objectUrl = URL.createObjectURL(blob);
                //  window.open(objectUrl);
            }
            this.showLoader = "";
            swal({
                title: 'Adjunto generado',
                text: 'Se ha descargardo el adjunto seleccionado.',
                type: 'success',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
    
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Adjunto no generado',
                text: 'El archivo no existe o no se encuentra en el directorio indicado.',
                type: 'warning',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            })
        });
      }
      
    onChangeBusqueda() {
        this.siniestros = [];
        this.busqueda.CodigoTitular = 0;
        this.searchStr = "";
        this.identificacionTitular = "";
    }
    onSelected(e: CompleterItem) {
        if (e != null) {
            let tit = this.listaTitulares.filter(a => a.CodigoTitular == e.originalObject.CodigoTitular);
            let titularseleccionado = new VamTitularEntity();
            titularseleccionado = this.cloneCambio(tit[0]);
            this.CodigoTitular=titularseleccionado.CodigoTitular;
            //console.log(tit);
        }
    }
    cloneCambio(c: VamTitularEntity) {
        let cambio = new VamTitularEntity();
        for (let prop in c) {
            cambio[prop] = c[prop];
        }
        return cambio;
    }
    buscarCedula() {
        this.siniestros = [];
        let infoTitular = new Titulares();
        infoTitular.Cedula = this.identificacionTitular;
         infoTitular.CodigoGrupo=this.codigoGrupo;
         infoTitular.CodigoCliente=this.busqueda.CodigoCliente;
         infoTitular.CodigoCiudad=this.CodigoCiudad;
        this.showLoader = "sk-loading";

        this.siniestralidadService.getTitularPorCedula(infoTitular).subscribe(info => {
            if (info.CodigoTitular != null && info.CodigoTitular > 0) {
                this.CodigoTitular = info.CodigoTitular;
               // console.log(info);
                //console.log(this.CodigoTitular);
                //console.log(info.CodigoTitular);
            } else {
                this.CodigoTitular = 0;
                swal({
                    title: 'Titular No Encontrado',
                    text: "No existe titular activo que pertenezca al cliente/grupo seleccionado con la indentificación ingresada.",
                    type: 'error',
                    confirmButtonColor: '#A14950',
                    confirmButtonText: 'Aceptar'
                });
            }
            this.showLoader = "";
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al consultar titular',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            });
            console.log(error)
        }
        );
    }
    consultarNotaCobranzas() {
        this.showLoader = "sk-loading";
        let cliente = new ConsultaCliente();
        cliente.Cliente = this.busqueda.CodigoCliente;
        cliente.Ciudad = this.CodigoCiudad;
        this.siniestralidadService.getNotasCobranza(cliente).subscribe(siniestros => {
            this.NotasCobranza = siniestros;
            if (this.NotasCobranza.length > 0) {
                this.NotasCobranza.forEach(item => {
                    item.NombreEstado = this.Estados.filter(a => a.Id == item.Estado)[0].Nombre;
                }
                );
            }
            this.showLoader = "";
            console.log(this.NotasCobranza);
        }, error => {
            this.showLoader = "";
            swal({
                title: 'Error al consultar las Notas de Cobranza  del cliente',
                text: error,
                type: 'error',
                confirmButtonColor: '#A14950',
                confirmButtonText: 'Aceptar'
            });
            console.log(error)
        });
    }
    descargar(archivo: Archivo) {
        archivo.Ruta=archivo.Ruta+"\\"+archivo.Nombre;
        this.movimientosService.getArchivo(archivo).subscribe(
            result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = null;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    blob = new Blob([fileBlob], {
                        type: 'application/pdf'
                    });
                }
                if (archivo.Extension.toUpperCase() == "JPG") {
                    blob = new Blob([fileBlob], {
                        type: 'image/jpg'
                    });
                }
                if (archivo.Extension.toUpperCase() == "PNG") {
                    blob = new Blob([fileBlob], {
                        type: 'image/png'
                    });
                }
                if (archivo.Extension.toUpperCase() == "XLSX" || archivo.Extension.toUpperCase() == "XLS") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                }
                if (archivo.Extension.toUpperCase() == "DOCX") {
                    blob = new Blob([fileBlob], {
                        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    });
                }
                if (archivo.Extension.toUpperCase() == "MSG") {
                    blob = new Blob([fileBlob], {
                        type: 'application/ms-outlook'
                    });
                }
                if (archivo.Extension.toUpperCase() == "RAR") {
                    blob = new Blob([fileBlob], {
                        type: 'application/x-rar-compressed'
                    });
                }
                if (archivo.Extension.toUpperCase() == "ZIP") {
                    blob = new Blob([fileBlob], {
                        type: '	application/zip'
                    });
                }
                if (archivo.Extension.toUpperCase() == "TXT") {
                    blob = new Blob([fileBlob], {
                        type: '	application/text'
                    });
                }

                let url = window.URL.createObjectURL(blob);
                a.href = url;
                if (archivo.Extension.toUpperCase() == "PDF") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "XLSX"||archivo.Extension.toUpperCase() == "XLS") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "DOCX") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "JPG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "PNG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "MSG") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "RAR") {
                    a.download = archivo.Nombre;
                }
                if (archivo.Extension.toUpperCase() == "ZIP") {
                    a.download = archivo.Nombre;
                }

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    if (archivo.Extension.toUpperCase() == "XLSX"||archivo.Extension.toUpperCase() == "XLS") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".xlsx");
                    }
                    if (archivo.Extension.toUpperCase() == "PDF") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".pdf");
                    }
                    if (archivo.Extension.toUpperCase() == "DOCX") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".docx");
                    }
                    if (archivo.Extension.toUpperCase() == "JPG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".jpg");
                    }
                    if (archivo.Extension.toUpperCase() == "PNG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".png");
                    }
                    if (archivo.Extension.toUpperCase() == "MSG") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".msg");
                    }
                    if (archivo.Extension.toUpperCase() == "RAR") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".rar");
                    }
                    if (archivo.Extension.toUpperCase() == "ZIP") {
                        window.navigator.msSaveOrOpenBlob(blob, archivo.Nombre + ".zip");
                    }
                    console.log("2");
                }
                else {
                    a.click();
                    console.log("3");
                    window.URL.revokeObjectURL(url);
                }
                //this.showLoader = "";
            },
            error => {
                console.log(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/siniestros.component.ts